export enum PinActionType {
    Withdraw = 'withdraw',
    Pay = 'pay',
    Create = 'create',
    Transfer = 'transfer',
    Deposit = 'deposit',
    TransactionDetails = 'transactiondetails',
    ResetPIN = 'resetpin',
    SendOrRequest = 'sendorrequest',
    CancelWithdraw = 'cancelwithdraw',
    WithdrawToBank = 'withdrawtobank',
    CardShowDetails = 'cardshowdetails',
    DeleteVirtualCard = 'deletevirtualcard',
    BlockPhysicalCard = 'blockphysicalcard',
    CardApply = 'cardapply',
    ResetCardPIN = 'changecardpin',
    CreateCardPIN = "createcardpin",
    DeleteWallet = "deletewallet",
    MobileTopup = "mobiletopup",
    WalletPinVerify = "walletpinverify",
    BillPay = "billpay",
    RegistrationPINCreate = "registrationpincreate",
    PINLogin = "PINLogin",
    LoginForgetPasscodeReset = "LoginForgetPasscodeReset",
    ResetPasscode = 'ResetPasscode',
}


// WEBPACK FOOTER //
// ./src/model/types/wallet-pin-action-type.ts